import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  CircularProgress,
} from "@mui/material";
import ProductCard from "../components/Categories/ProductCard";

const ProductPage = () => {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const query = new URLSearchParams(location.search).get("q")?.toLowerCase().trim() || "";

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch("/productos/ver-productos/");
        const data = await response.json();
        const all = data.products || [];

        const filtered = all.filter((p) => {
          const name = p.name?.toLowerCase() || "";
          const brand = p.brand?.toLowerCase() || "";
          const category = p.category?.toLowerCase() || "";
          const section = p.section?.toLowerCase() || "";
          return (
            name.includes(query) ||
            brand.includes(query) ||
            category.includes(query) ||
            section.includes(query)
          );
        });

        setProducts(filtered);
        setFilteredProducts(filtered);
      } catch (error) {
        console.error("Error al buscar productos:", error);
        setFilteredProducts([]);
      } finally {
        setLoading(false);
      }
    };

    if (query) fetchData();
  }, [query]);

  return (
    <Box sx={{ px: 2, py: 4, maxWidth: 1300, mx: "auto" }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", mb: 3 }}>
        Resultados para: "{query}"
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
          <CircularProgress />
        </Box>
      ) : filteredProducts.length > 0 ? (
        <Grid container spacing={2}>
          {filteredProducts.map((prod) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={prod.id}>
              <ProductCard product={prod} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography align="center" sx={{ color: "#777", mt: 4 }}>
          No se encontraron productos relacionados con tu búsqueda.
        </Typography>
      )}
    </Box>
  );
};

export default ProductPage;
